export default function({ state, dispatch, commit }, { id, provider, questionnaire_id, update }) {

    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + id + '/charting',
        data: {
            questionnaire_id,
            update
        }
    }, {
        root: true
    })
    .then((response) => {
        if(response.data && response.data.result) {
            const text = response.data.result
            const chartObj = {
                ...response,
                text
            }
            commit('updateChartNote', {
                id,
                questionnaire_id,
                chartObj
            })
        }
        return response
    })
    .catch((error) => {
        throw error
    })
}
